import React from "react";
import { useHistory } from "react-router-dom";

import "./MobileUtilisationNavigator.css";


export default function MobileUtilisationNavigator({
    selected = "summary"
})
{
    const history =
        useHistory();


    //--------------------------------------------------------
    // Navigation
    //--------------------------------------------------------

    const goSummary =
        () =>
        {
            history.push(
                "/homeutilisation"
            );
        };


    const goDepartment =
        () =>
        {
            history.push(
                "/utilisationsummaryorganisation/-100"
            );
        };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div className="mobile-utilisation-navigator">

            <button
                type="button"
                className={
                    "mobile-utilisation-navigator-item " +
                    (
                        selected === "summary"
                            ? "selected"
                            : ""
                    )
                }
                onClick={goSummary}
            >
                Summary
            </button>

            <div className="mobile-utilisation-navigator-divider" />

            <button
                type="button"
                className={
                    "mobile-utilisation-navigator-item " +
                    (
                        selected === "department"
                            ? "selected"
                            : ""
                    )
                }
                onClick={goDepartment}
            >
                By Department
            </button>

        </div>

    );
}